import React from 'react';
import useApp from '../../store/app/appContext';
import UsersProvider from '../../store/users/usersProvider';
import UserInfo from '../../containers/account/UserInfo';
import PageWrapper from '../../containers/app/PageWrapper';

function AccountPage() {  

  const { appState: { user }} = useApp();

  if (!user) return '';
  if (!user._id) return '';
  
  return (
    <UsersProvider>
      <PageWrapper navbar title='My Account'>
        <UserInfo />
      </PageWrapper>
    </UsersProvider>
  )
}

export default AccountPage
